export enum ENDPOINT {
  ADDQnA = "/AddQnA",
  AUTHLOGIN = "/AuthLogin",
  BALANCE = "/balance",
  BATCHNUMBER = "/BatchNumberLookUp",
  CURRENCY = "/currency",
  CUSTOMACCOUNT = "/CustomAccount",
  FORGETPASSWORD = "/ForgetPassword",
  GENERATEDAILY = "/GenerateReportDaily",
  GENERATEDATERANGE = "/GenerateReportRange",
  GENERATEOTP = "/generateotp",
  GETAPPROVERS = "/GetApprovers",
  GETAPPROVERSPOISITON = "/GetApproversPosition",
  GETFORAPPROVAL = "/GetForApproval",
  IDTYPE = "/IdType",
  LOGIN = "/UserLogin",
  OCCUPATION = "/Occupation",
  OTP = "/generateotp",
  PATCHNOTES = "/patchNotes",
  POCANCEL = "/PoCancelReason",
  PROVINCE = "/Province",
  QUESTIONLIST = "/QuestionList",
  PURPOSEOFTRANSACTION = "/PurposeOfTransaction",
  REGULARPARTNERS = "/RegularPartners",
  RELATION = "/RelationToSender",
  RESETPASSOWRD = "/ResetPassword",
  SENDBATCHNUMBER = "/SendBatchNumber",
  SOURCEOFFUND = "/SourceOfFund",
  SSOAUTH = "/ssoauth",
  SSOLINK = "/ssolink",
  TRACKAPPROVER = "/TrackBatchApprover",
  UPDATEFORAPPROVAL = "/UpdateForApproval",
  UPDATEPASSWORD = "/UpdatePassword",
  UPDATETHEME = "/UpdateTheme",
  UPDATEQnA = "/UpdateQnA",
  USERQUESTION = "/UserQuestion",
  VALIDATEOTP = "/validateotp",
  VALIDATEPASSWORD = "/ValidateAnswer",
  VERSION = "/Version",
}
